import { Checkbox, Space } from "antd";
import { translate } from "../../../../core";
import { TableItem, TableColumnsProps, UpdateSelectionMode } from "./types";

export const getTableColumns = ({
  tableData,
  setTableData,
  excludedItemIds,
  setExcludedItemIds,
  includedItemIds,
  setIncludedItemIds,
  updateSelectionMode,
}: TableColumnsProps) => [
    {
      title: <Space>
        <Checkbox 
          checked={updateSelectionMode === UpdateSelectionMode.Manual
            ? tableData.every(it => includedItemIds.includes(it.id))
            : tableData.every(it => !excludedItemIds.includes(it.id))
          }
          onChange={e => {
            const checked = e.target.checked
            if (checked) {
              if (updateSelectionMode === UpdateSelectionMode.Manual) {
                setIncludedItemIds(tableData.map(it => it.id))
              } else {
                setExcludedItemIds([])
              }
            } else {
              if (updateSelectionMode === UpdateSelectionMode.Manual) {
                setIncludedItemIds([])
              } else {
                setExcludedItemIds(tableData.map(it => it.id))
              }
            }
          }}
        />
        <span>{translate("select")}</span>
      </Space>,
      key: "select",
      width: 50,
      render: (_: any, record: TableItem) => (
        <Checkbox
          checked={updateSelectionMode === UpdateSelectionMode.Manual ? includedItemIds.includes(record.id) : !excludedItemIds.includes(record.id)}
          onChange={(e) => {
            const checked = e.target.checked

            if (updateSelectionMode === UpdateSelectionMode.Manual) {
              if (checked)
                setIncludedItemIds(pre => [...pre, record.id])
              else
                setIncludedItemIds(pre => pre.filter(id => id !== record.id))
            }

            if (updateSelectionMode === UpdateSelectionMode.Automatic) {
              if (checked)
                setExcludedItemIds(pre => pre.filter(id => id !== record.id))
              else
                setExcludedItemIds(pre => [...pre, record.id])
            }
          }}
        />
      ),
    },
    {
      title: translate("sku"),
      dataIndex: "sku",
      key: "sku",
      width: 100,
    },
    {
      title: translate("type"),
      dataIndex: "type",
      key: "type",
      width: 150,
    },
    {
      title: translate("category"),
      dataIndex: "category",
      key: "category",
      width: 150,
    },
    {
      title: translate("description"),
      dataIndex: "description",
      key: "description",
      width: 900,
    },
    {
      title: translate("ours", "price"),
      dataIndex: "price",
      key: "price",
      width: 150,
      render: (value: number) => value ? new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(value) : '',
    },
    {
      title: translate("sales_period"),
      dataIndex: "salePeriod",
      key: "salePeriod",
      width: 350,
    },
    {
      title: translate("vendor"),
      dataIndex: "vendor",
      key: "vendor",
      width: 150,
    },
    {
      title: translate("style"),
      dataIndex: "style",
      key: "style",
      width: 150
    },
    {
      title: translate("pattern_number_abbr"),
      dataIndex: "patternNumber",
      key: "patternNumber",
      width: 200
    },
    {
      title: translate("on_web"),
      dataIndex: "showOnWeb",
      key: "showOnWeb",
      width: 120,
      render: (showOnWeb: boolean) => <Checkbox checked={showOnWeb} disabled />,
    },
    {
      title: translate("non_purchasable"),
      dataIndex: "nonPurchasable",
      key: "nonPurchasable",
      width: 120,
      render: (nonPurchasable: boolean) => <Checkbox checked={nonPurchasable} disabled />,
    },
  ];
